<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-2">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <i class="fa fa-list-alt text-white"></i>
          </div>
          <div class="header-text-container">
            <h5 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Resumo de Abate</h5>
            <p class="text-muted mb-0 small">Pesquisa e gestão de resumos de abate</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-2">
            <!-- Search Pill -->
            <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir/HTML">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="Exportar CSV">
                        <i class="fa fa-file-text-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <cec-input-data ref="dt1" v-model="dt1" class="mx-1" input-class="border-0 bg-transparent" style="width: 150px" @keydown.enter.native="pesquisar()" />
                    <span class="text-muted mx-1">até</span>
                    <cec-input-data ref="dt2" v-model="dt2" class="mx-1" input-class="border-0 bg-transparent" style="width: 150px" @keydown.enter.native="pesquisar()" />
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span>Adicionar</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtro.avancado">
          <div class="px-3 pb-2">
              <div class="card card-filter-premium compact-filter p-2 border-0 shadow-sm">
                  <b-row>
                    <b-col md="6">
                      <funcionario-pesquisa 
                        @retornaId="responsavelId = $event"
                        :idInicial="responsavelId"
                        label="Responsável"
                        place="Responsável Opcional"
                        labelBotao=""
                        ref="responsavelpesquisa"
                        idModal="responsavelpesquisa"
                        class="cliente-pesquisa-wrapper"
                        :arredondado="true"
                      />
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>
    
      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <!-- Main table element -->
            <b-table 
                  class="mb-0 table-finance"
                  id="table-transition-example"
                  ref="tbl"
                  show-empty
                  empty-text="Informe o filtro para ver os pesquisas "
                  :dark="isDark"
                  small
                  responsive 
                  :tbody-tr-class="rowClassSelecionado"
                  hover 
                  :sticky-header="stickyHeight"
                  @row-clicked="clicarLinha"
                  @row-dblclicked="onEdit"
                  :items="itensFiltrados" 
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage">
              <template #head(ID)>
              <SetFilter
                label="ID"
                v-model="filtros.ID"
                :options="opcoes.ID"
                :normalizeFn="normalize"
                dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>
            <template #head(LOTE)>
              <SetFilter
                label="Lote"
                v-model="filtros.LOTE"
                :options="opcoes.LOTE"
                :normalizeFn="normalize"
                dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>

            <!-- Cabeçalho: Situação -->
            <template #head(DATA)>
              <SetFilter
                label="Data"
                v-model="filtros.DATA"
                :options="opcoes.DATA"
                :normalizeFn="normalize"
                dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>
            <template #head(STATUS)>
              <SetFilter
                label="Situação"
                v-model="filtros.STATUS"
                :options="opcoes.STATUS"
                :normalizeFn="normalize"
                dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>
            <template #head(OP_TIPO)>
              <SetFilter
                label="Tipo"
                v-model="filtros.OP_TIPO"
                :options="opcoes.OP_TIPO"
                :normalizeFn="normalize"
                dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>
            
            <template #head(NOME_RESPONSAVEL_ENT)>
              <SetFilter
                label="Responsável"
                v-model="filtros.NOME_RESPONSAVEL_ENT"
                :options="opcoes.NOME_RESPONSAVEL_ENT"
                :normalizeFn="normalize"
                dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>
            <template #head(USUARIO)>
              <SetFilter
                label="Usuário"
                v-model="filtros.USUARIO"
                :options="opcoes.USUARIO"
                :normalizeFn="normalize"
                dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>
            <template #head(ANIMAIS)>
              <SetFilter
                label="Animais"
                v-model="filtros.ANIMAIS"
                :options="opcoes.ANIMAIS"
                :normalizeFn="normalize"
                dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>      
            <template #head(QUANT)>
              <SetFilter
                label="Peso"
                v-model="filtros.QUANT"
                :options="opcoes.QUANT"
                :normalizeFn="normalize"
                dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>      
            <template #head(INICIO_COLETA)>
              <SetFilter
                label="Início"
                v-model="filtros.INICIO_COLETA"
                :options="opcoes.INICIO_COLETA"
                :normalizeFn="normalize"
                dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>      
            <template #head(TERMINO_COLETA)>
              <SetFilter
                label="Término"
                v-model="filtros.TERMINO_COLETA"
                :options="opcoes.TERMINO_COLETA"
                :normalizeFn="normalize"
                dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>          
              <template #cell(STATUS)="item">
                <b-badge pill :variant="colorirStatus(item.item.STATUS)">{{traduzirStatus(item.item.STATUS)}}</b-badge>
              </template>      
              <template #cell(OP_TIPO)="item">
                <b-badge pill :variant="colorirTipo(item.item.OP_TIPO)">{{traduzirTipo(item.item.OP_TIPO)}} {{ item.item.ABATE_ID }}</b-badge>
              </template>      
              <template #cell(actions)="item">
                <div class="d-flex align-items-center gap-1 justify-content-end">
                  <b-button type="button" @click.stop.prevent="abrirModalInfo(item.item)" variant="soft-info" pill class="btn-icon-only shadow-sm" title="Mais Detalhes" v-b-tooltip.hover>
                    <i class="fa fa-info"></i>
                  </b-button>
                  <b-button v-if="item.item.STATUS == '2'" type="button" @click.stop.prevent="onDetalhes(item.item)" variant="soft-info" pill class="btn-icon-only shadow-sm" title="Mais Detalhes" v-b-tooltip.hover>
                    <i class="fa fa-info"></i>
                  </b-button>
                  <b-button v-if="item.item.STATUS != '2'" type="button" @click.stop.prevent="imprimir(item.item.ID)" variant="soft-secondary" pill class="btn-icon-only shadow-sm" title="Re-imprimir" v-b-tooltip.hover>
                    <i class="fa fa-print"></i>
                  </b-button>
                  <b-button type="button" @click="abrirModalUpload(item.item)" :variant="'soft-' + colorirBotaoUpload(item.item)" pill class="btn-icon-only shadow-sm" title="Foto ou Imagem" v-b-tooltip.hover>
                    <i class="fa fa-file-image-o"></i>
                  </b-button>
                  <b-button v-if="item.item.STATUS != '2' || item.item.OP_STATUS  === '1'" type="button" @click="abrirModalCancelamento(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Cancelar" v-b-tooltip.hover>
                    <i class="fa fa-close"></i>
                  </b-button>
                </div>
              </template>

              <!-- Alternativamente, usando custom-foot para linha de rodapé completa -->
              <template #custom-foot="{ fields }">
                <b-tr>
                  <b-td class="font-weight-bold">Lotes: ({{ itensFiltrados.length }})</b-td>
                  <b-td v-for="(field, idx) in fields.slice(1)" :key="idx" :class="['text-right', 'font-weight-bold']">
                    <span v-if="field.key === 'QUANT'">{{ vlPesoRodape }}</span>
                  </b-td>
                </b-tr>
              </template>
             
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                            MODAL INFO 
      ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-info" 
          id="modal-info" 
          hide-header
          hide-footer
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          centered
          size="xl"
          scrollable 
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #17a2b8 0%, #117a8b 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-info text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Detalhes do Pedido</h5>
                <small class="text-white opacity-75">Informações completas do resumo de abate</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-info')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="modal-info-bar mb-4 p-3 rounded d-flex align-items-center justify-content-between bg-light border">
                <div class="d-flex align-items-center">
                    <div class="avatar-circle mr-3 bg-info text-white">
                        <i class="fa fa-list-alt"></i>
                    </div>
                    <div>
                        <small class="text-muted d-block">Pedido ID</small>
                        <span class="font-weight-bold text-dark">{{modalDetalhes.dados.ID}}</span>
                    </div>
                </div>
                <div class="d-flex align-items-center border-left px-4">
                    <div>
                        <small class="text-muted d-block">Data Produção</small>
                        <span class="font-weight-bold text-dark">{{modalDetalhes.dados.DATA}}</span>
                    </div>
                </div>
                <div class="text-right">
                    <small class="text-muted d-block">Situação</small>
                    <b-badge pill :variant="colorirStatus(modalDetalhes.dados.STATUS)">{{traduzirStatus(modalDetalhes.dados.STATUS)}}</b-badge>
                </div>
            </div>

            <b-row class="mb-4">
                <b-col md="6">
                    <div class="p-3 rounded border bg-light-soft">
                        <small class="modal-label-premium">Balanceiro</small>
                        <h6 class="mb-0 font-weight-bold text-dark">{{modalDetalhes.dados.NOME_BALANCEIRO}}</h6>
                    </div>
                </b-col>
                <b-col md="6">
                    <div class="p-3 rounded border bg-light-soft">
                        <small class="modal-label-premium">Tipo</small>
                        <b-badge pill :variant="colorirTipo(modalDetalhes.dados.OP_TIPO)">{{traduzirTipo(modalDetalhes.dados.OP_TIPO)}}</b-badge>
                    </div>
                </b-col>
            </b-row>

            <div class="modal-section-title mb-3">
                <i class="fa fa-history mr-2 text-primary"></i> Dados de Alteração
            </div>
            <b-row class="mb-4">
                <b-col md="3">
                    <small class="modal-label-premium">Data</small>
                    <span class="font-weight-bold">{{modalDetalhes.dados.DT_ALTERACAO || '-'}}</span>
                </b-col>
                <b-col md="3">
                    <small class="modal-label-premium">Usuário</small>
                    <span class="font-weight-bold">{{modalDetalhes.dados.USUARIO_ALTERACAO || '-'}}</span>
                </b-col>
                <b-col md="6">
                    <small class="modal-label-premium">Motivo</small>
                    <span class="font-weight-bold">{{modalDetalhes.dados.OBS || '-'}}</span>
                </b-col>
            </b-row>

            <div class="modal-section-title mb-3">
                <i class="fa fa-refresh mr-2 text-primary"></i> Dados de Reabertura
            </div>
            <b-row class="mb-4">
                <b-col md="3">
                    <small class="modal-label-premium">Data</small>
                    <span class="font-weight-bold">{{modalDetalhes.dados.DATA_REABRIR || '-'}}</span>
                </b-col>
                <b-col md="3">
                    <small class="modal-label-premium">Usuário</small>
                    <span class="font-weight-bold">{{modalDetalhes.dados.USUARIO_REABRIR || '-'}}</span>
                </b-col>
            </b-row>

            <div class="modal-section-title mb-3">
                <i class="fa fa-table mr-2 text-primary"></i> Itens do Resumo
            </div>
            <div class="bg-white rounded border shadow-sm overflow-hidden">
                <b-table 
                    class="mb-0 table-finance"
                    striped 
                    hover 
                    show-empty
                    empty-text="Venda sem Produtos lançados "
                    stacked="md"
                    small
                    responsive 
                    :sticky-header="true"
                    select-mode="single"
                    selectable
                    :items="modalDetalhes.tabela.items" 
                    :fields="modalDetalhes.tabela.fields">
                </b-table>
            </div>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-info')">
            FECHAR
          </b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                              MODAL FECHAMENTO
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-fechamento" 
          id="modal-fechamento" 
          hide-header
          hide-footer
          centered
          size="lg"
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          @shown="focusModalFechamento()" 
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-align-justify text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Fechamento da Ordem de Abate</h5>
                <small class="text-white opacity-75">Finalização e geração de títulos financeiros</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-fechamento')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="modal-info-bar mb-4 p-3 rounded d-flex align-items-center justify-content-between bg-light border">
                <div class="d-flex align-items-center">
                    <div class="avatar-circle mr-3 bg-primary text-white">
                        <i class="fa fa-user"></i>
                    </div>
                    <div>
                        <small class="text-muted d-block">Fornecedor</small>
                        <span class="font-weight-bold text-dark">{{registro.CLIENTE_ID}}</span>
                    </div>
                </div>
                <div class="text-right">
                    <small class="text-muted d-block">ID / Lote</small>
                    <span class="badge badge-dark px-3">{{registro.ID}} - {{registro.LOTE}}</span>
                </div>
            </div>

            <b-row>
              <b-col sm="12">
                <cliente-pesquisa 
                    @retornaId="registro.CLIENTE_ID = $event"
                    :idInicial="registro.CLIENTE_ID"
                    :desabilitarInput="true"
                    id="edCLIENTE_ID"
                    idModal="modalCliente"
                    label="Fornecedor"
                    place="Informe o Fornecedor"
                    labelBotao=""
                    :arredondado="true">
                </cliente-pesquisa>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col sm="12">
                <cliente-pesquisa 
                  @retornaId="registro.MARCHANT_ID = $event"
                  :idInicial="registro.MARCHANT_ID"
                  :desabilitarInput="true"
                  idModal="modalMarchant"
                  label="Marchante"
                  id="edMARCHANT_ID"
                  place="Informe o Marchant"
                  labelBotao=""
                  :arredondado="true">
                </cliente-pesquisa>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col sm="12">
                <cliente-pesquisa 
                    @retornaId="registro.FAZENDA_ID = $event"
                    :idInicial="registro.FAZENDA_ID"
                    :desabilitarInput="true"
                    idModal="modalFazenda"
                    label="Fazenda"
                    id="edFAZENDA_ID"
                    place="Informe a Fazenda"
                    labelBotao=""
                    :arredondado="true">
                </cliente-pesquisa>
              </b-col>
            </b-row> 
            
            <hr class="my-4">
            
            <b-row>
              <b-col sm="6">
                <b-form-group label="Gerar Título ao:" label-class="modal-label-premium">
                  <b-form-select  :plain="true" 
                                  id="comboGerarTitulo"
                                  ref="comboGerarTitulo"
                                  :state="registro.OP_DEVEDOR != null"
                                  v-model="registro.OP_DEVEDOR"
                                  :options="tipoGerarTitulo"
                                  class="custom-input-premium">
                    </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="6" v-if="registro.campos.DT_VENCIMENTO_ARECEBER == true">
                <b-form-group label="Data Vencimento" label-class="modal-label-premium">
                  <b-form-input  type="date" id="edDT_VENCIMENTO_ARECEBER"  
                          :state="registro.DT_VENCIMENTO_ARECEBER != null"
                          v-model="registro.DT_VENCIMENTO_ARECEBER" class="custom-input-premium"> </b-form-input>
                </b-form-group>
              </b-col>  
            </b-row>

            <b-row v-if="registro.campos.VL_SERVICO_CABECA == true" class="mt-2">
              <b-col sm="4">
                <b-form-group label="Serviço por Cabeça:" label-class="modal-label-premium">
                  <vue-autonumeric  v-model="registro.VL_SERVICO_CABECA" 
                          :options="'Brazilian'" 
                          class="form-control custom-input-premium text-right font-weight-bold"  
                          :class="{
                            'is-valid' : registro.VL_SERVICO_CABECA && registro.VL_SERVICO_CABECA > 0.00,
                            'is-invalid' : !registro.VL_SERVICO_CABECA || registro.VL_SERVICO_CABECA <= 0.00
                          }">
                  </vue-autonumeric>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label="Cabeças:" label-class="modal-label-premium">
                  <b-form-input  type="text" id="edNR_CABECAS"  
                          :disabled="true"
                          v-model="registro.NR_CABECAS" class="custom-input-premium text-right"> </b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label="Total do Serviço:" label-class="modal-label-premium">
                  <vue-autonumeric  v-model="registro.VL_TOTAL_SERVICO" 
                          :options="'Brazilian'" 
                          :disabled="true"
                          class="form-control custom-input-premium text-right font-weight-bold bg-light"  >
                  </vue-autonumeric>
                </b-form-group>
              </b-col>
            </b-row>

            <hr class="my-4">

            <b-row v-if="registro.campos.HISTORICO_ARECEBER_ID == true">
              <b-col sm="6">
                <b-form-group label="Histórico - Caixa" label-class="modal-label-premium">
                    <b-form-select  
                                    v-model="registro.HISTORICO_ARECEBER_ID" 
                                    :options="optionshistoricos" 
                                    :state="registro.HISTORICO_ARECEBER_ID != null"
                                    ref="combohistorico"
                                    class="custom-input-premium">
                      <template slot="first">
                        <option :value="null" >Todos os Históricos</option>
                      </template>
                    </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Centro de Custo" label-class="modal-label-premium">
                    <b-form-select  
                                    v-model="registro.CENTRO_CUSTO_ARECEBER_ID" 
                                    :options="optionsCentroCustos" 
                                    :state="registro.CENTRO_CUSTO_ARECEBER_ID != null"
                                    ref="comboCentroCusto"
                                    class="custom-input-premium">
                      <template slot="first">
                        <option :value="null" >Todos os Centros de Custos</option>
                      </template>
                    </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="success" pill class="px-4 font-weight-bold mr-2" @click="onFechamento()">
            <i class="fa fa-check mr-1"></i> FINALIZAR FECHAMENTO
          </b-button>
          <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-fechamento')">
            <i class="fa fa-times mr-1"></i> FECHAR
          </b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                              MODAL REMOVER ARQUIVO 
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-upload-remove" 
          id="modal-upload-remove" 
          hide-header
          hide-footer
          centered
          size="lg"
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          @shown="focusModalRemoveArquivo()" 
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #f86c6b 0%, #c82333 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-trash text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Remover Arquivo da Pesagem</h5>
                <small class="text-white opacity-75">Confirmação de exclusão de documento</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-upload-remove')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="modal-info-bar mb-4 p-3 rounded d-flex align-items-center justify-content-between bg-light border">
                <div class="d-flex align-items-center">
                    <div class="avatar-circle mr-3 bg-danger text-white">
                        <i class="fa fa-file"></i>
                    </div>
                    <div>
                        <small class="text-muted d-block">ID do Registro</small>
                        <span class="font-weight-bold text-dark">{{modalUpload.id}}</span>
                    </div>
                </div>
                <div class="text-right">
                    <small class="text-muted d-block">Data</small>
                    <span class="font-weight-bold text-dark">{{modalUpload.data}}</span>
                </div>
            </div>
            
            <div class="alert alert-warning border-warning shadow-sm">
                <i class="fa fa-exclamation-triangle mr-2"></i>
                <strong>Atenção:</strong> Esta ação removerá permanentemente o arquivo associado a este registro. Deseja continuar?
            </div>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="danger" pill class="px-4 font-weight-bold mr-2" @click="onRemoverArquivo()">
            <i class="fa fa-trash mr-1"></i> CONFIRMAR REMOÇÃO
          </b-button>
          <b-button variant="soft-secondary" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-upload-remove')">
            CANCELAR
          </b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                              MODAL UPLOAD 
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-upload" 
          id="modal-upload" 
          hide-header
          hide-footer
          centered
          scrollable 
          size="lg"
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          @shown="focusModalUpload()" 
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #4a90e2 0%, #1456a3 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-file-image-o text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Arquivo da Pesagem</h5>
                <small class="text-white opacity-75">Upload e visualização de comprovantes</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-upload')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="modal-info-bar mb-4 p-3 rounded d-flex align-items-center justify-content-between bg-light border">
                <div class="d-flex align-items-center">
                    <div class="avatar-circle mr-3 bg-info text-white">
                        <i class="fa fa-tag"></i>
                    </div>
                    <div>
                        <small class="text-muted d-block">ID do Registro</small>
                        <span class="font-weight-bold text-dark">{{modalUpload.id}}</span>
                    </div>
                </div>
                <div class="text-right">
                    <small class="text-muted d-block">Data</small>
                    <span class="font-weight-bold text-dark">{{modalUpload.data}}</span>
                </div>
            </div>

            <div v-if="modalUpload.imagem == null">
                <div class="modal-section-title mb-3">
                    <i class="fa fa-upload mr-2 text-primary"></i> Selecionar Arquivo
                </div>
                <b-form-file
                  accept=".jpeg, .jpg, .png"
                  v-model="modalUpload.file"
                  :state="Boolean(modalUpload.file)"
                  ref="edUpload"
                  placeholder="Escolha um arquivo de Imagem, Foto (Arraste ele pra cá)"
                  drop-placeholder="Arraste o arquivo pra cá..."
                  class="custom-file-premium mb-3">
                </b-form-file>
            </div>

            <div v-if="modalUpload.imagem != null">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <div class="modal-section-title mb-0 border-0">
                        <i class="fa fa-image mr-2 text-primary"></i> Visualização do Arquivo
                    </div>
                    <b-button variant="soft-danger" size="sm" pill @click.stop.prevent="onRemoverArquivo()">
                        <i class="fa fa-trash mr-1"></i> Remover Imagem
                    </b-button>
                </div>
                <div class="image-preview-container rounded border p-2 bg-light text-center">
                    <b-img :src="'data:image/jpg;base64,'+modalUpload.imagem" fluid alt="Comprovante de Pesagem" class="rounded shadow-sm"></b-img>
                </div>
            </div>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button v-if="modalUpload.imagem == null" variant="success" pill class="px-4 font-weight-bold mr-2" @click="onUpload()" :disabled="!modalUpload.file">
            <i class="fa fa-upload mr-1"></i> ENVIAR ARQUIVO
          </b-button>
          <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="onFecharModalUpload()">
            <i class="fa fa-times mr-1"></i> FECHAR
          </b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                              MODAL CANCELAMENTO 
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-cancelamento" 
          id="modal-cancelamento" 
          hide-header
          hide-footer
          centered
          size="lg"
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          @shown="focusModalCancelamento()" 
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #f86c6b 0%, #c82333 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-ban text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Cancelar Resumo de Abate</h5>
                <small class="text-white opacity-75">Esta ação não poderá ser desfeita</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-cancelamento')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="modal-info-bar mb-4 p-3 rounded d-flex align-items-center justify-content-between bg-light border">
                <div class="d-flex align-items-center">
                    <div class="avatar-circle mr-3 bg-danger text-white">
                        <i class="fa fa-tag"></i>
                    </div>
                    <div>
                        <small class="text-muted d-block">ID do Registro</small>
                        <span class="font-weight-bold text-dark">{{modalUpload.id}}</span>
                    </div>
                </div>
                <div class="text-right">
                    <small class="text-muted d-block">Número do Lote</small>
                    <span class="badge badge-danger px-3">{{modalUpload.lote}}</span>
                </div>
            </div>

            <div class="modal-section-title mb-3">
                <i class="fa fa-commenting mr-2 text-danger"></i> Motivo do Cancelamento
            </div>
            <b-form-group label="Descreva o motivo da anulação deste resumo:" label-class="modal-label-premium">
                <b-form-input 
                  type="text" 
                  ref="edMotivoCancelamento" 
                  id="edMotivoCancelamento" 
                  placeholder="Ex: Erro na pesagem, Lote duplicado, etc." 
                  :state="Boolean(modalUpload.motivoCancelamento)"
                  v-model="modalUpload.motivoCancelamento"
                  class="custom-input-premium py-4">
                </b-form-input>
            </b-form-group>

            <div class="alert alert-soft-danger mt-3 border-0">
                <i class="fa fa-info-circle mr-2"></i>
                O cancelamento liberará os animais e lotes vinculados para novos lançamentos.
            </div>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-end">
          <b-button variant="danger" pill class="px-4 font-weight-bold mr-2" @click="cancelar()" :disabled="!modalUpload.motivoCancelamento">
            <i class="fa fa-check mr-1"></i> CONFIRMAR CANCELAMENTO
          </b-button>
          <b-button variant="soft-secondary" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-cancelamento')">
            FECHAR
          </b-button>
        </div>
      </b-modal>
    </div>
    

    <ModalAlertaResultadoGrande
      ref="modalConfirmarResultadoGrande"
      :count="resultadoPendenteCount"
      @confirmar="confirmarCarregarResultadoGrande"
      @cancelar="cancelarCarregarResultadoGrande"
      @shown="onModalShown"
      @hidden="onModalHidden"
    />
  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import FuncionarioPesquisa from '../../pesquisa/FuncionarioPesquisa.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import moment from 'moment'
import VueAutonumeric from 'vue-autonumeric'
import Tools from '@/tools/tools.js'

import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { mapGetters } from 'vuex';
import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'


export default {
  components: {
    VueButtonSpinner,
    ClientePesquisa,
    FuncionarioPesquisa,
    CecInputData,
    VueAutonumeric,
    SetFilter,
    ModalAlertaResultadoGrande
  },

  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    preferVh: 62,
    useExternalPaging: true,
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'LOTE', type: 'string', label: 'Lote' },
      { key: 'DATA', type: 'date', label: 'Data' },
      { key: 'STATUS', type: 'string', label: 'Situação',
        labelMap: { 
         '0' :'EM CADASTRO',
         '1' :'PRONTO PRA COLETA',
         '2' :'CANCELADO' ,
         '3' :'EM COLETA' ,
         '4' :'FINALIZADO' }
      }, 
      { key: 'OP_TIPO', type: 'string', label: 'Tipo',
        labelMap: { 
         '0' :'DIARIO',
         '1' :'LOTE' }
      },
      { key: 'NOME_RESPONSAVEL_ENT', type: 'string', label: 'Responsável' },
      { key: 'USUARIO', type: 'string', label: 'Usuário'},
      { key: 'ANIMAIS', type: 'number', label: 'Animais'} ,
      { key: 'QUANT', type: 'currency', label: 'Peso'} ,
      { key: 'INICIO_COLETA', type: 'date', label: 'Início'} ,
      { key: 'TERMINO_COLETA', type: 'date', label: 'Término'} ,
    ]
  })],
  data () {
    return {
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      desabilitarSelectRow: false,
      registroSelecionadoId: null,
      filtro: {
        avancado: false
      },
      modalDetalhes: {
        dados: {
          ID                : null,
          BALANCEIRO_ID     : null,
          NOME_BALANCEIRO   : null,
          DATA              : null,
          DT_LANCAMENTO     : null,
          USUARIO           : null,
          DT_ALTERACAO      : null,
          USUARIO_ALTERACAO : null,
          OBS               : null,
          STATUS            : null,
          CENTRO_ESTOQUE_ID : null,
          NOME_CENTRO_ESTOQUE : null,
          OP_TIPO           : null,
          ABATE_ID          : null,
          LOTE              : null,
          DATA_REABRIR      : null,
          USUARIO_REABRIR   : null, 
          HORA_INICIO_ATENDIMENTO : null,


        },
        tabela: {
          fields: [
            {
              key: "PRODUTO_ID",
              class:'text-right', 
              label: 'ID'
            },
            {
              key: "DESCRICAO",
              label: 'Produto'
            },
            {
              key: "PECAS",
              label: 'Peças',
              class:'text-right' 
            },
            {
              key: "PESO",
              label: 'Quant KG',
              class:'text-right', 
              formatter: (value, key, item) => 
                  value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
            }
          ],
          items: []
        }
      },
      cancelamento: {
        parametros: {
          overlayBaixando: false,
          permissao: false,
          processando: false,
          busy: false,
          processoPorTerminal: '0',
        },
        dados: {
          titulo: null,
          id: null,
          nomeCliente: '',
          documento: '',
          parcela: '',
          motivo: '',
          dataVencimento: 0.00,
          gta: '',
          valorDocumento: 0.00,
          usuario: ''
        }
      },
      registro: {
        ID: null,
        CLIENTE_ID: null,
        FAZENDA_ID: null,
        OP_DEVEDOR: null,
        VL_SERVICO_CABECA: null,
        NR_CABECAS: null,
        VL_TOTAL_SERVICO: null,
        DT_VENCIMENTO_ARECEBER: null,
        HISTORICO_ARECEBER_ID: null,
        CENTRO_CUSTO_ARECEBER_ID: null,
        USUARIO_CADASTRO: null,
        campos: {
          VL_SERVICO_CABECA : false,
          NR_CABECAS: false,
          VL_TOTAL_SERVICO: false,
          DT_VENCIMENTO_ARECEBER : false,
          HISTORICO_ARECEBER_ID : false,
          CENTRO_CUSTO_ARECEBER_ID : false
        }
      },
      tipoGerarTitulo: [
        {value: '0', text: '0 - Ninguém (Sem taxa de Serviço)'},
        {value: '1', text: '1 - Marchant (Cobrar Serviço)'},
        {value: '2', text: '2 - Fornecedor (Cobrar Serviço)'},
        {value: '3', text: '3 - Fazenda (Cobrar Serviço)'},
      ],
      optionshistoricos: [],
      optionsCentroCustos: [],
      dadosModalInfo: {
        id: null,
        documento: null,
        dataVenda : null,
        nomeCliente: null,
        nomeVendedor: null,
        usuarioAlteracao: null,
        dataAlteracao: null,
        motivoAlteracao: null,
        usuarioCancelamento: null,
        dataCancelamento: null,
        motivoCancelamento: null,
        total: 0.00

      },
      tabelaItens: {
        fields: [
          {
            key: "CODIGO_NOME_PRODUTO",
            label: 'Produto'
          },
          {
            key: "QUANT",
            label: 'Quantidade',
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: "PECAS",
            label: 'Peças'
          },
          {
            key: "TX_UNIDADE_COMERCIAL",
            label: 'UND'
          },
          {
            key: 'VL_UNT', 
            class:'text-right', 
            label: 'Valor (R$)', 
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },
          {
            key: 'VL_DESCONTO', 
            class:'text-right', 
            label: 'Desconto (R$)', 
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },
          {
            key: 'VL_TOTAL_BRUTO', 
            class:'text-right', 
            label: 'Total (R$)', 
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          }
        ],
        items: []
      },
      optionsTipoProcesso: [
        { value: '0', text: '0 -Ambos' },
        { value: '1', text: '1 - Próprio' },
        { value: '2', text: '2 - Serviço' }
      ],
      status: '',
      isBusy: false,
      fields: [
        {
          key: "ID",
          label: 'Id',
          sortable: true,
          class:'text-right font-weight-bold my-left-border my-left-right my-left-bottom',
        },
        {
          key: "LOTE",
          label: 'Lote', 
          sortable: true,
          class: 'my-left-border my-left-right my-left-bottom', 
          thStyle: { width: "5%" }, 
        },
        {
          key: "DATA",
          label: 'Data', 
          sortable: true,
          
          class:'text-right my-left-border my-left-right my-left-bottom',
          formatter: (value, key, item) => 
            moment(String(value)).format('DD/MM/YYYY')
        },
        {
          key: "STATUS",
          label: 'Status', 
          sortable: true,
          class: 'my-left-border my-left-right my-left-bottom'
        },
        {
          key: "OP_TIPO",
          label: 'Tipo', 
          sortable: true,
          class: 'my-left-border my-left-right my-left-bottom'
        },
        {
          key: "NOME_RESPONSAVEL_ENT",
          label: 'Responsável',
          class: 'my-left-border my-left-right my-left-bottom', 
          sortable: true 
        },
        {
          key: "USUARIO",
          label: 'Usuário',
          class: 'my-left-border my-left-right my-left-bottom', 
          sortable: true 
        },
        {
          key: "ANIMAIS",
          label: 'Itens',
          class:'text-right  my-left-border my-left-right my-left-bottom',
          sortable: true 
        },
        {
          key: 'QUANT', 
          class:'text-right  my-left-border my-left-right my-left-bottom',
          label: 'Peso', 
          sortable: true,
          formatter: (value, key, item) => 
            value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2}) : null
        },
        {
          key: "INICIO_COLETA",
          label: 'Inicio', 
          class:'text-right  my-left-border my-left-right my-left-bottom',
          sortable: true,
          formatter: (value, key, item) => 
            value ? moment(String(value)).format('DD/MM/YYYY HH:mm:ss') : null
        },
        {
          key: "TERMINO_COLETA",
          label: 'Término', 
          class:'text-right  my-left-border my-left-right my-left-bottom',
          sortable: true,
          formatter: (value, key, item) => 
          value ? moment(String(value)).format('DD/MM/YYYY HH:mm:ss') : null
        },
        {
          key: "actions",
          label: 'Ações',
          class:'text-right  my-left-border my-left-right my-left-bottom p-0',
          thStyle: { width: "10%" }
        }
      ],
      currentPage: 1,
      perPage: 50,
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      modalUpload: {
        file: null,
        data: null,
        nomeCliente: null,
        id: null,
        motivoCancelamento: null,
        lote: null,
        imagem: null
      },
      columns: [
        {title: 'ID', dataKey: 'id'},
        {title: 'Name', dataKey: 'name'},
        {title: 'Country', dataKey: 'country'}
      ],
      statusOptions: [
        {text: 'CANCELADA', value: '0'},
        {text: 'LANCAMENTOS PRINCIPAIS', value: '1'},
        {text: 'PLANEJAMENTO INICIADO', value: '2'},
        {text: 'PRONTO PARA COLETA', value: '3'},
        {text: 'COLETA INICIADA', value: '4'},
        {text: 'COLETA ENCERRADA', value: '5'},
        {text: 'FECHADO', value: '6'}
      ],
      rows: [
        {'id': 1, 'name': 'Shaw', 'country': 'Tanzania'},
        {'id': 2, 'name': 'Nelson', 'country': 'Kazakhstan'},
        {'id': 3, 'name': 'Garcia', 'country': 'Madagascar'}
      ]
    }
  },
 
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    vlPesoRodape() {
      let auxValor = (this.itensFiltrados || []).reduce((s, i) => s + (Number(i.QUANT) || 0), 0)
      return auxValor ? auxValor.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : '0,000'
    },
    ehProcessoPorTerminal: function()  {
        return this.processoPorTerminal == '1' ? true : false
      
    },
    dt1: {
      get () {
        return this.$store.getters['abateResumo/DT1']
      }, 
      set (value) {
        this.$store.commit("abateResumo/SET_DT1", value);
      }
    },
    dt2: {
      get () {
        return this.$store.getters['abateResumo/DT2']
      }, 
      set (value) {
        this.$store.commit("abateResumo/SET_DT2", value);
      }
    },
    responsavelId: {
      get () {
        return this.$store.getters['abateResumo/RESPONSAVEL_ID']
      }, 
      set (value) {
        this.$store.commit("abateResumo/SET_RESPONSAVEL_ID", value)
      }
    },
    lista: {
      get () {
        
        return this.$store.getters['abateResumo/LISTA']
      }, 
      set (value) {
        this.$store.commit("abateResumo/SET_LISTA", value)
      }
    },
    registroPosicao: {
      get () {
        return this.$store.getters['abateResumo/REGISTRO_POSICAO']
      }, 
      set (value) {
        this.$store.commit("abateResumo/SET_REGISTRO_POSICAO", value)
      }
    },
    registroId: {
      get () {
        return this.$store.getters['abateResumo/REGISTRO_ID']
      }, 
      set (value) {
        this.$store.commit("abateResumo/SET_REGISTRO_ID", value)
      }
    }
  },
  methods: {
    async abrirModalInfo(item) {
      try {
        this.$store.commit('controle/setAguardando', true)
        this.modalDetalhes.tabela.items = null
        this.modalDetalhes.dados.ID = null
        this.modalDetalhes.dados.DATA = null
        this.modalDetalhes.dados.DATA_REABRIR = null
        this.modalDetalhes.dados.NOME_BALANCEIRO = null
        this.modalDetalhes.dados.NOME_CENTRO_ESTOQUE = null
        this.modalDetalhes.dados.OBS = null
        this.modalDetalhes.dados.ABATE_ID = null
        this.modalDetalhes.dados.OP_TIPO = null
        this.modalDetalhes.dados.LOTE = null
        
        this.modalDetalhes.dados.USUARIO = null
        this.modalDetalhes.dados.USUARIO_ALTERACAO = null
        this.modalDetalhes.dados.USUARIO_REABRIR = null
        this.modalDetalhes.dados.OBS = null
        this.modalDetalhes.dados.HORA_INICIO_ATENDIMENTO = null
        
        try {
      
          const response = await this.$http.get(`/api/protected/producao/resumo/getTraduzidoById/${item.ID}`)
      
          this.modalDetalhes.dados = response.data[0]
          this.modalDetalhes.dados.DATA = Tools.formatarDataBR(this.modalDetalhes.dados.DATA)
          this.$refs['modal-info'].show()
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação indisponível' )
        }
        
        await this.atualizarListaDetalhe(this.modalDetalhes.dados.ID)

      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    cancelar() {
      if (this.modalUpload.motivoCancelamento == null) {
        this.toastCount++
        this.$root.$bvToast.toast('Informe o motivo!', {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        return
      }
      this.$store.commit('controle/setAguardando', true)
      this.$http.post( `/api/protected/producao/resumo/delete/${this.modalUpload.id}/${this.modalUpload.motivoCancelamento}`)
      .then(() => {
        for (let i = 0; i < this.lista.length; i++) {
          if (this.lista[i].ID == this.modalUpload.id) {
             this.lista[i].STATUS = '2'
          }
        }
        this.$store.commit('controle/setAguardando', false)
        this.$refs['modal-cancelamento'].hide()
        return
      })
      .catch(erro => {
        this.$store.commit('controle/setAguardando', false)
        this.$refs['modal-cancelamento'].hide()
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Não foi possivel Cancelar: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 4000,
              variant: 'warning',
              appendToast: true
            })
          }
      })

      
    },
    abrirModalRemoveArquivo(item) {
      this.$store.commit('controle/setAguardando', true)
      this.modalUpload.file = null
      this.modalUpload.nomeCliente = item.NOME_FORNECEDOR
      this.modalUpload.id = item.ID
      this.modalUpload.lote = item.LOTE


      this.$refs['modal-upload-remove'].show()
      this.$store.commit('controle/setAguardando', false)
    },
    getImagem(id) {
      return new Promise((resolve, reject) => {
        this.$http.get( `/api/protected/producao/resumo/getArquivo/${id}`)
        .then((result) => {
          this.modalUpload.imagem = result.data
          resolve(true)
        })
        .catch(erro => {
          this.$refs['modal-cancelamento'].hide()
            if (erro.response && erro.response.status == 400) {
              this.toastCount++
              this.$root.$bvToast.toast(`Não foi possivel Carregar a Imagem: ${erro.response.data}`, {
                title: 'Falha',
                autoHideDelay: 4000,
                variant: 'warning',
                appendToast: true
              })
            } else {
              this.toastCount++
              this.$root.$bvToast.toast(`Não foi possivel carregar a Imagem: ${erro}`, {
                title: 'Falha',
                autoHideDelay: 4000,
                variant: 'warning',
                appendToast: true
              })
            }
          reject(false)
        })
      })
    },
    async abrirModalUpload(item) {
      this.$store.commit('controle/setAguardando', true)
      this.modalUpload.file = null
      this.modalUpload.nomeCliente = item.NOME_FORNECEDOR
      this.modalUpload.id = item.ID
      this.modalUpload.data = item.DATA
      this.modalUpload.lote = item.LOTE
      this.modalUpload.itemDaTabela = item
      this.modalUpload.imagem = null
      
      if( await this.getImagem(item.ID) == false) {
        return
      }
      
      this.$store.commit('controle/setAguardando', true)
      this.$refs['modal-upload'].show()
      
      
    },
    focusModalRemoveArquivo() {
    },
    focusModalUpload() {
      if (this.modalUpload.imagem == null) {
        this.$refs.edUpload.$refs.input.focus()
      }
    },
    async onRemoverArquivo() {
      this.$store.commit('controle/setAguardando', true)
      
      this.$http.post(`api/protected/producao/resumo/removerArquivo/${this.modalUpload.id}`)
      .then(() => {
        this.$store.commit('controle/setAguardando', false)
        this.modalUpload.imagem = null
        
        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast(`Aviso!!! Arquivo Removido com sucesso `, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
      })
      .catch((err) => {
        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast(`Aviso!!!  Falha na Remoção ${err}`, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'warning',
          appendToast: true
        })
      })
    },
    onFecharModalUpload() {
      this.$store.commit('controle/setAguardando', false)
      this.$refs['modal-upload'].hide()
    },
    async onUpload() {
      if (this.modalUpload.file == null ) {
        this.$root.$bvToast.toast(`Aviso!!!  Informe todos os campos obrigatórios`, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'warning',
          appendToast: true
        })
        return
      }
      this.$store.commit('controle/setAguardando', true)
      let formData = new FormData()
      formData.append('files', this.modalUpload.file, this.modalUpload.file.name)

      this.$http.post(`api/protected/producao/resumo/upload/${this.modalUpload.id}/${window.localStorage.getItem('login')}`, formData)
      .then(result => {
        this.$store.commit('controle/setAguardando', false)
        

        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast(`Aviso!!! Upload com sucesso `, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
        this.getImagem(this.modalUpload.id)
        return
      })
      .catch((err) => {
        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast(`Aviso!!!  Falha no Upload ${err}`, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'warning',
          appendToast: true
        })
      })
    },
    async atualizarListaDetalhe (id) {
      try { 
        let result =  await this.$http.get(`/api/protected/producao/resumo/getItensTerminal/${id}`)
        this.modalDetalhes.tabela.items = result.data
      } catch(err) {
         Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possível listar a pesagem' )
      }
    },
    abrirModalCancelamento(item) {
      this.$store.commit('controle/setAguardando', true)
      this.modalUpload.file = null
      this.modalUpload.nomeCliente = null
      this.modalUpload.id = item.ID
      this.modalUpload.lote = item.LOTE
      this.modalUpload.motivoCancelamento = null


      this.$refs['modal-cancelamento'].show()
      this.$store.commit('controle/setAguardando', false)
    },
    async criarListaHistorico() {
      this.$http.get('/api/protected/historico/listartodos')
      .then((data) => {
        if (data) {
          this.optionshistoricos = []
          let i
          for (i = 0; i < data.data.length; i++) {
            this.optionshistoricos.push({value: data.data[i].ID, text: data.data[i].CODIGONOME})
          }
        }
        return true
      }).catch((error) => {
        return false
      })
    },
    async criarListaCentroCusto() {
      this.$http.get('/api/protected/centrocusto/listartodos')
      .then((data) => {
        if (data) {
          this.optionsCentroCustos = []
          let i
          for (i = 0; i < data.data.length; i++) {
            this.optionsCentroCustos.push({value: data.data[i].ID, text: data.data[i].CODIGONOME})
          }
        }
        return true
      }).catch((error) => {
        return false
      })
    },
    async getTotalAnimais(id) {
      this.registro.NR_CABECAS =  null
      this.$http.get(`/api/protected/abate/getTotalAnimaisByAbateId/${id}`)
      .then((data) => {
        this.registro.NR_CABECAS = data.data
        return true
      }).catch((error) => {
        return false
      })
    },
    async abrirModalFechamento(item) {
      this.$store.commit('controle/setAguardando', true)
      let reg = await this.getRegistroById(item.ID)
      if (reg == null) {
        
        this.$store.commit('controle/setAguardando', false)
        this.$bvToast.toast(`Não foi possível encontrar a Ordem de Abate!!`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        return
      }

      
      if (await this.criarListaCentroCusto() == false) {
        this.$store.commit('controle/setAguardando', false)
        this.$bvToast.toast(`Não foi possível encontrar os Centros de Custos!!`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        return
      }

      if (await this.criarListaHistorico() == false) {
        this.$store.commit('controle/setAguardando', false)
        this.$bvToast.toast(`Não foi possível encontrar os Históricos do Caixa!!`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        return
      }
      if (await this.getTotalAnimais(item.ID) == false) {
        this.$store.commit('controle/setAguardando', false)
        this.$bvToast.toast(`Não foi possível encontrar o Total de Animais!!`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        return
      }

      
      
      this.registro.ID = reg.data[0].ID
      this.registro.CLIENTE_ID = reg.data[0].CLIENTE_ID
      this.registro.FAZENDA_ID = reg.data[0].FAZENDA_ID
      this.registro.OP_DEVEDOR = reg.data[0].OP_DEVEDOR ? reg.data[0].OP_DEVEDOR : '0'
      this.registro.VL_SERVICO_CABECA = reg.data[0].VL_SERVICO_CABECA ? reg.data[0].VL_SERVICO_CABECA : 0.00
      this.registro.NR_CABECAS = reg.data[0].NR_CABECAS
      this.registro.VL_TOTAL_SERVICO = reg.data[0].VL_TOTAL_SERVICO ? reg.data[0].VL_TOTAL_SERVICO : 0.00
      this.registro.DT_VENCIMENTO_ARECEBER = reg.data[0].DT_VENCIMENTO_ARECEBER ? moment(new Date(reg.data[0].DT_VENCIMENTO_ARECEBER)).format('YYYY-MM-DD') : null
      this.registro.HISTORICO_ARECEBER_ID = reg.data[0].HISTORICO_ARECEBER_ID
      this.registro.CENTRO_CUSTO_ARECEBER_ID = reg.data[0].CENTRO_CUSTO_ARECEBER_ID
      this.registro.USUARIO_CADASTRO = window.localStorage.getItem('login')

      this.$refs['modal-fechamento'].show()
      this.$store.commit('controle/setAguardando', false)
    },
    async getRegistroById(id) {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/producao/getById/${id}`)
        .then((result) =>{
          resolve(result)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
        
    },
    focusModalCancelamento() {
      this.$refs.edMotivoCancelamento.focus()
    },
    focusModalFechamento() {
      this.$refs.comboGerarTitulo.focus()
    },
    limpar() {
      this.$store.commit("abateResumo/SET_LIMPAR", null)
    },
    colorirTipoServico(valor) {
      if (valor == '0') return 'success' //Proprio
      else if (valor == '1') return 'orange' // Servico
      else return 'success'
    },
    colorirFechadoDiario(valor) {
      if (valor == '0') return 'text-yellow' //Nao
      else if (valor == '1') return 'text-success' // Sim
      else if (valor == '1') return 'text-success' // Sim
      else return 'text-yellow'//nao
    },
    colorirExistePlano(valor) {
      if (valor == '0') return 'text-yellow' //Sim
      else if (valor == '1') return 'text-success' // Nao
      else return 'text-dark'
    },
    colorirStatus(valor) {
      if (this.ehProcessoPorTerminal == true) {
        if (valor == '0') return 'warning' // LANCANDO
        else if (valor == '1') return 'info' //PRONTO PARA COLETA
        else if (valor == '2') return 'red' // EXCLUIDO
        else if (valor == '3') return 'primary' // EM COLETA
        else if (valor == '4') return 'success' // FINALIZADO
        else return 'gray-dark'

        
      } else {
        if (valor == '0') return 'warning' // LANCANDO
        else if (valor == '1') return 'info' //PRONTO PARA COLETA
        else if (valor == '2') return 'red' // EXCLUIDO
        else if (valor == '3') return 'primary' // EM COLETA
        else if (valor == '4') return 'success' // FINALIZADO
        else return 'gray-dark'
      }
    },
    traduzirStatus(item) {
      if (item == null) return ''
      
      if (this.ehProcessoPorTerminal == true) {
        switch (item) {
          case  '0' : return 'EM CADASTRO'
          case  '1' : return 'PRONTO PRA COLETA'
          case  '2' : return 'CANCELADO' 
          case  '3' : return 'EM COLETA' 
          case  '4' : return 'FINALIZADO' 
          default: 
            break;
        }
      } else {
        switch (item) {
          case  '0' : return 'EM CADASTRO'
          case  '1' : return 'PRONTO PRA COLETA'
          case  '2' : return 'CANCELADO' 
          case  '3' : return 'EM COLETA' 
          case  '4' : return 'FINALIZADO' 
          default: 
            break;
        }
      }
    },
    colorirBotaoUpload(item) {
      if (item.EXISTE_ARQUIVO == '0') return 'outline-warning' // N EXISTE
      else if (item.EXISTE_ARQUIVO == '1') return 'green' //EXISTE
      else return ''
    },
    colorirTipo(valor) {
      if (valor == '0') return 'primary' // FECHAMAENTO DIARIO
      else if (valor == '1') return 'info' //LOTE
      else return 'gray-dark'

      
    },
    traduzirTipo(item) {
      if (item == null) return ''
      switch (item) {
        case  '0' : return '0 - DIARIO'
        case  '1' : return '1 - LOTE' 
        default: 
          break;
      }
    },
    clicarLinha(item) {
      this.$store.commit("abateResumo/SET_REGISTRO_SELECIONADO_ID", item.ID)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['abateResumo/REGISTRO_SELECIONADO_ID']
      return item.ID === selId ? 'cec-row-selected' : ''
    },
    details (item) {
      alert(JSON.stringify(item.item.ID))
    },
    onEdit (item) {
      if (this.desabilitarSelectRow == true) {
        return
      }
      this.registroId = item.ID
      
      this.$store.commit("abateResumo/SET_REGISTRO_SELECIONADO_ID", item.ID)
      this.$store.commit('controle/setAguardando', true)
      this.$router.push(`/producao/resumo/edit/${item.ID}`)
    },
    onDetalhes (item) {
      this.$store.commit('controle/setAguardando', true)
      this.$router.push(`/producao/resumo/detalhes/${item.ID}`)
    },
    onColetar (item) {
      this.$store.commit('controle/setAguardando', true)
      this.$router.push(`/producao/resumo/coleta/${item.ID}`)
    },
    novo () {
      this.$router.push(`/producao/resumo/add`)
    },
    async pesquisar (ctx) {
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      const inputs = [this.$refs.dt1, this.$refs.dt2]
      inputs.forEach(input => {
        if (input && input.$el) input.$el.blur()
        else if (input && input.blur) input.blur()
      })
      
      this.isBusy = true
      
      try {
        const result = await this.$store.dispatch('abateResumo/GERAR_LISTA')

        // Verifica se precisa de confirmação
        if (result && result.needsConfirmation) {
          this.resultadoPendente = result.data
          this.resultadoPendenteCount = result.count
          this.isBusy = false // Fecha loading antes de mostrar modal
          this.$refs.modalConfirmarResultadoGrande.show()
          return
        }

        this.status = true
      } catch (err) {
        console.error('Erro ao pesquisar resumos:', err)
        this.toastCount++
        this.$root.$bvToast.toast(`Ocorreu uma falha ao executar a Pesquisa`, {
          title: 'Atenção',
          autoHideDelay: 3000,
          variant: 'danger',
          appendToast: true
        })
      } finally {
        this.isBusy = false
      }
    },
    confirmarCarregarResultadoGrande() {
      // Fecha o modal
      this.$refs.modalConfirmarResultadoGrande.hide()
      
      // Carrega os dados pendentes
      if (this.resultadoPendente) {
        this.$store.commit('abateResumo/SET_LISTA', this.resultadoPendente)
        
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      }
    },
    cancelarCarregarResultadoGrande() {
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
    },
    onModalShown() {
      this.modalConfirmacaoAberto = true
    },
    onModalHidden() {
      this.modalConfirmacaoAberto = false
    },
    exportarHtml() {
      printHtmlReport({
        rows: this.itensFiltrados,
        columns: this.fields.filter(f => f.key !== 'actions'),
        reportTitle: 'Listagem de Resumo de Abate',
        printedBy: window.localStorage.getItem('login') ?? '—',
        filename: 'resumo_abate.html',
      });
    },
    exportarExcel() {
      exportExcelXlsx({
        rows: this.itensFiltrados,
        columns: this.fields.filter(f => f.key !== 'actions'),
        filename: 'resumo_abate.xlsx',
      });
    },
    exportarCsv() {
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.fields.filter(f => f.key !== 'actions'),
        filename: 'resumo_abate.csv',
      });
    },
    imprimir (id) {
      this.$store.commit('controle/setAguardando', true)
      let parametros = {
        params:{
            id: id,
            usuario: window.localStorage.getItem('login')
          },
        responseType: 'arraybuffer'
      }
      let uri = `/api/protected/relatorios/abate/resumo`
      this.$http.get(uri, parametros)
        .then(response => {
          this.$store.commit('controle/setAguardando', false)
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relAbateResumoMiudo.pdf') 
          link.download = 'relAbateResumoMiudo.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = parametros.params.id +' Relatório do Miudo'
            }, 2000);
          }

          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          this.toastCount++
          if (erro.response.status == 400) {
            console.log(erro.response)
            this.toastCount++
            this.$root.$bvToast.toast(`Não foi possivel gerar o relatorio`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          } else {
            this.toastCount++
            this.$root.$bvToast.toast(`${erro}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'danger',
              appendToast: true
            })
          }
        })
    },
    async carregarParametrosSistema() {
      await this.$http.get(`/api/protected/parametro/getParametrosResumoAbate`)
      .then(data => {
        
          this.processoPorTerminal =  data.data[0].OP_RESUMO_ABATE_POR_TERMINAL
      })
    },
    handleKeydown(event) {
      if (event.key === "Insert") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.$refs.btAdicionar.click()
      } 
      
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // Garantir que o aguardando está desligado ao entrar na listagem
      vm.$store.commit('controle/setAguardando', false)

      // Garantir foco no dt1 ao exibir a página
      vm.$nextTick(() => {
        if (vm.$refs.dt1) {
          if (typeof vm.$refs.dt1.focus === 'function') vm.$refs.dt1.focus()
          else if (vm.$refs.dt1.$el) vm.$refs.dt1.$el.focus()
        }
      })
    })
  },
  async created () {
    await this.carregarParametrosSistema()
    
    // Pesquisa apenas se a lista estiver vazia (primeira vez ou acesso direto)
    // Quando vem do cadastro, dados já estão atualizados na store
    if (!this.lista || this.lista.length === 0) {
      await this.pesquisar()
    }
  },
  async mounted () {
    if ((this.lista) && (this.lista.length)) {
      if (this.registroPosicao >= 0) {
        
        //Desabilita o Selectrow para que possa selecionar a linha da tabela
        //sem que isso execute o clicar na linha @rowSelect da tabela
        //é usado no metodo edit
        this.desabilitarSelectRow = true
        await this.$refs.tabelaPrincipal.selectRow(this.registroPosicao)
        this.desabilitarSelectRow = false
      }
    }

    // Adiciona o evento de keydown ao document
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown)
      this.registroSelecionadoId = this.$store.getters['abateResumo/REGISTRO_SELECIONADO_ID'] ? parseInt(this.$store.getters['abateResumo/REGISTRO_SELECIONADO_ID']) : null
      
      
    }, 200)

    this.$nextTick(() => {
      if (this.$refs.dt1) {
        if (typeof this.$refs.dt1.focus === 'function') this.$refs.dt1.focus()
        else if (this.$refs.dt1.$el) this.$refs.dt1.$el.focus()
      }
    })
  },
  beforeDestroy() {
    // Remove o evento de keydown ao destruir o componente
    document.removeEventListener("keydown", this.handleKeydown);
  },

  watch: {
    'registro.OP_DEVEDOR' : function() {
      if (this.registro.OP_DEVEDOR == '0') {
        this.registro.campos.VL_SERVICO_CABECA = false
        this.registro.campos.NR_CABECAS = false
        this.registro.campos.DT_VENCIMENTO_ARECEBER = false
        this.registro.campos.HISTORICO_ARECEBER_ID = false
        this.registro.campos.CENTRO_CUSTO_ARECEBER_ID = false
      } else {
        this.registro.campos.VL_SERVICO_CABECA = true
        this.registro.campos.NR_CABECAS = true
        this.registro.campos.DT_VENCIMENTO_ARECEBER = true
        this.registro.campos.HISTORICO_ARECEBER_ID = true
        this.registro.campos.CENTRO_CUSTO_ARECEBER_ID = true
      }
    },
    'registro.VL_SERVICO_CABECA': function() {
      let cabecas = this.registro.NR_CABECAS
      let valor = this.registro.VL_SERVICO_CABECA
      this.registro.VL_TOTAL_SERVICO = parseFloat(cabecas * valor).toFixed(2)
    }
  }
}
</script>

<style>
/********************************CABECALHO FIXO***********************/

/* Cabeçalho sticky — cobre com e sem .table-responsive */
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

/* Evita “vazar” borda quando sticky 
.b-table-sticky-header > .table.b-table,
.b-table-sticky-header .table-responsive > .table.b-table {
  border-collapse: separate;
}
*/
/* Faz o wrapper responsivo rolar verticalmente respeitando a altura calculada */
.b-table-sticky-header .table-responsive {
  max-height: inherit;   /* pega o max-height do contêiner sticky */
  overflow-y: auto;      /* cria rolagem interna da tabela */
}

/* Colunas fixas (stickyColumn) também com wrapper responsivo */
.table.b-table th.b-table-sticky-column,
.table.b-table td.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table th.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table td.b-table-sticky-column {
  z-index: 3;
}

/* Destaca a linha selecionada (vence striped/dark e aplica nos <td>) */
.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #c2cfd6  !important;
  color: #000000 !important;
}

/* Links/ícones continuam visíveis */
.table.b-table tbody tr.cec-row-selected a {
  color: #000000 !important;
}

/* Colunas sticky também pintadas */
.table.b-table tbody tr.cec-row-selected td.b-table-sticky-column {
  background-color: #c2cfd6  !important;
}

/* (opcional) hover da linha já selecionada */
.table.b-table tbody tr.cec-row-selected:hover > td {
  background-color: #c2cfd6  !important;
}


/* Layout do bloco Callout */
.callout { padding: .05rem .5rem; }
.callout-row {
  display: flex;
  align-items: center;
  gap: .5rem;
}

/* Caixa do gráfico com tamanho fixo */
.cec-chart-box {
  width: 140px;      /* ajuste se quiser maior/menor */
  height: 40px;      /* combina com :height do componente */
  display: flex;
  align-items: center;
}

/* Faz o canvas preencher a caixa */
.cec-chart-box canvas {
  width: 100% !important;
  height: 100% !important;
}

/* Regras para evitar problemas de posicionamento nos gráficos */
.callout .cec-chart-wrapper { position: static; left: auto; top: auto; float: none; width: auto; }
.cec-chart-wrapper canvas { width: auto !important; }

/* premium styles */
.modal-header-premium {
  border-bottom: none;
  position: relative;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.1);
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

/* Table Enhancements */
.table-finance thead th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 4px 6px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 2px 6px !important;
  color: #4a5568;
  font-size: 0.8rem;
}

.table-finance tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
}

.btn-soft-primary {
  background-color: rgba(32, 168, 216, 0.1);
  color: #20a8d8;
  border: none;
}
.btn-soft-primary:hover {
  background-color: #20a8d8;
  color: white;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}
.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.bg-soft-warning { background-color: rgba(255, 193, 7, 0.12) !important; }
.bg-soft-success { background-color: rgba(40, 167, 69, 0.12) !important; }
.bg-soft-danger { background-color: rgba(220, 53, 69, 0.12) !important; }

.modal-footer-premium {
  background-color: #f8f9fa;
  border-top: 1px solid #edf2f7;
}

.list-header-premium {
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 1.5rem 2rem;
  margin-bottom: 1rem;
  border-radius: 1rem;
}

.card-filter-premium {
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  background: #fdfdfd;
}

.btn-icon-only {
  width: 38px;
  height: 38px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/producao/resumoabate/ResumoAbateListagem.vue